import { ApiDashboardElement } from '@highimpact-frontend/api-types';
import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { setWidgetConfigPanelState } from '../../../state/dashboard/slice';
import { useWidgetConfigContext } from './WidgetConfigContext';

import { useDashboardLibraryDispatch } from '../../../runtime/DashboardLibraryProvider';
interface UnconfiguredWidgetPlaceholderProps {
  message: string;
  gridId: number;
  gridType: 'grids' | 'reports';
  widgetId: number;
  elementType: Exclude<
    ApiDashboardElement['element_type'],
    'collection' | 'readonlytext'
  >;
  configPanelState?: 'Configuring' | 'Reconfiguring';
}

function UnconfiguredWidgetPlaceholder({
  message,
  gridId,
  gridType,
  widgetId,
  elementType,
  configPanelState = 'Configuring',
}: UnconfiguredWidgetPlaceholderProps) {
  const dispatch = useDashboardLibraryDispatch();
  const { widgetIsOnConfig } = useWidgetConfigContext();

  const openConfigPanel = () => {
    dispatch(
      setWidgetConfigPanelState({
        state: configPanelState,
        elementType,
        gridId,
        gridType,
        widgetId,
      })
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 2,
        textAlign: 'center',
        padding: '15px',
      }}
    >
      <Typography variant="h5">{message}</Typography>
      <Button
        variant="contained"
        type="button"
        disabled={widgetIsOnConfig}
        onClick={openConfigPanel}
      >
        Configurer
      </Button>
    </Box>
  );
}

export default UnconfiguredWidgetPlaceholder;
